import { app } from '../../../../bootstrap/core';
import { focusInvalid, formValidityChanged } from './formValidation.directive';

app.directive('focusInvalid', focusInvalid);
app.directive('formValidityChanged', formValidityChanged);
